import React from "react";

const STAGE_META = {
  e_rank: { title: "E-Rank", color: "text-slate-300", glow: "rgba(148,163,184,0.4)", art: "◈" },
  d_rank: { title: "D-Rank", color: "text-emerald-300", glow: "rgba(16,185,129,0.5)", art: "◉" },
  c_rank: { title: "C-Rank", color: "text-cyan-300", glow: "rgba(0,229,255,0.5)", art: "◈◈" },
  b_rank: { title: "B-Rank", color: "text-blue-300", glow: "rgba(59,130,246,0.6)", art: "◆" },
  a_rank: { title: "A-Rank", color: "text-purple-300", glow: "rgba(168,85,247,0.6)", art: "◆◆" },
  s_rank: { title: "S-Rank", color: "text-fuchsia-300", glow: "rgba(217,70,239,0.7)", art: "★" },
  monarch: { title: "Shadow Monarch", color: "text-amber-300", glow: "rgba(245,158,11,0.8)", art: "☠" },
};

export default function Avatar({ stage = "e_rank", level = 1, name = "Hunter" }) {
  const meta = STAGE_META[stage] || STAGE_META.e_rank;
  return (
    <div className="flex flex-col items-center py-6" data-testid="avatar-card">
      <div className="relative avatar-aura">
        <div
          className="relative z-10 w-40 h-40 border-2 border-cyan-400/60 flex items-center justify-center bg-gradient-to-br from-violet-900/30 via-black to-cyan-900/30"
          style={{ boxShadow: `0 0 40px -5px ${meta.glow}, inset 0 0 40px rgba(0,0,0,0.6)` }}
        >
          <div className={`text-6xl ${meta.color} font-display drop-shadow-[0_0_15px_rgba(0,229,255,0.7)]`}>
            {meta.art}
          </div>
          <div className="absolute top-1 left-1 text-[9px] font-mono-tech text-cyan-400/70">
            ID:{String(level).padStart(3, "0")}
          </div>
          <div className="absolute bottom-1 right-1 text-[9px] font-mono-tech text-violet-400/70">
            SYS.OK
          </div>
        </div>
        {/* Corner brackets */}
        <span className="absolute -top-2 -left-2 w-3 h-3 border-t-2 border-l-2 border-cyan-400" />
        <span className="absolute -top-2 -right-2 w-3 h-3 border-t-2 border-r-2 border-cyan-400" />
        <span className="absolute -bottom-2 -left-2 w-3 h-3 border-b-2 border-l-2 border-cyan-400" />
        <span className="absolute -bottom-2 -right-2 w-3 h-3 border-b-2 border-r-2 border-cyan-400" />
      </div>
      <div className="mt-4 text-center">
        <div className="label-tech">Rank</div>
        <div className={`h-display text-xl ${meta.color}`} data-testid="avatar-rank">{meta.title}</div>
        <div className="mt-1 text-xs text-slate-400 font-mono-tech">{name}</div>
      </div>
    </div>
  );
}
